import { SubcontractorSelectDisplayBlock as SubcontractorSelectDisplayBlockType } from '../../types/blueprint'
import { Unanswered } from '../DisplayBlock.style'

import { Text } from '@/components/shared-components/BUI/Text'
import { UserInfoOverlay } from '@/components/shared-components/UserInfoOverlay'
import { useTemplateRenderer } from '@/context/templateRendererContext'
import { useUser } from '@/context/userContext'
import {
  createCommaSeparatedElements,
  createCommaSeparatedString,
} from '@/utils/createCommaSeparated'

type Props = {
  block: SubcontractorSelectDisplayBlockType
  maxWidth?: number
}

export const SubcontractorSelectDisplayBlock: React.FC<Props> = ({
  block,
  maxWidth,
}) => {
  const { adminUser } = useUser() ?? {}
  const { projectId } = useTemplateRenderer() ?? {}

  if (!block.value) return <Unanswered />

  if (adminUser?.id) {
    return (
      <Text
        as="div"
        style={maxWidth ? { maxWidth, wordBreak: 'break-word' } : {}}
      >
        {createCommaSeparatedElements(
          block.value.map((subbie) => (
            <UserInfoOverlay
              noIcon
              key={subbie.id}
              id={subbie.id}
              mode="SUBCONTRACTOR"
              projectId={projectId}
            >
              {subbie.name}
            </UserInfoOverlay>
          )),
          true
        )}
      </Text>
    )
  }

  return (
    <Text>
      {createCommaSeparatedString(
        block.value.map((subbie) => subbie.name),
        true
      )}
    </Text>
  )
}
